import { createRouter, defineRoute, param, Route } from "type-route";

export const { RouteProvider, useRoute, routes } = createRouter({
  // `/` is the website's home page rather than part of the app (site/plugin.ts), so signing in
  // has its own page, which is where Apple and Google send you back to.
  signIn: defineRoute("/signin"),
  stash: defineRoute("/stash"),
  archive: defineRoute("/archive"),
  settings: defineRoute("/settings"),
  trash: defineRoute("/trash"),
  // The reader: the saved copy of an item, over whichever list you opened it from
  item: defineRoute({ itemId: param.path.string }, (p) => `/item/${p.itemId}`),
  // Where the Chrome extension sends you to sign in (extension/ExtensionPage.tsx). `id` is the
  // extension's own ID, which only a dev build of the web app listens to.
  extension: defineRoute({ id: param.query.optional.string }, () => "/extension"),
});

export type Routes = Route<typeof routes>;
